module.exports = __webpack_public_path__ + "img/004.7d45c314.jpg";